<template>
  <div class="chat-view">
    <v-alert
      v-if="error"
      type="error"
      variant="tonal"
      closable
      class="alert-bar"
      @click:close="error = null"
    >
      {{ error }}
    </v-alert>

    <div class="chat-container">
      <ChatLayout
        :clinic-id="selectedClinicId"
        @error="handleError"
        @clinic-change="$emit('clinic-change', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useChatStore } from '@/stores/chat'
import { useClinicsStore } from '@/stores/clinics'
import ChatLayout from '@/components/chat/ChatLayout.vue'

const props = defineProps({
  selectedClinicId: {
    type: [String, Number],
    default: null
  }
})

const emit = defineEmits(['clinic-change'])

const chatStore = useChatStore()
const clinicsStore = useClinicsStore()

const error = ref(null)

const handleError = (errorMessage) => {
  error.value = errorMessage
}

onMounted(async () => {
  try {
    if (!clinicsStore.clinics.length) {
      await clinicsStore.fetchClinics()
    }
    await chatStore.loadConversations()
  } catch (err) {
    handleError(err.message || 'Error al inicializar el chat')
  }
})
</script>

<style scoped>
.chat-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.alert-bar {
  flex-shrink: 0;
  margin: 0;
  border-radius: 0;
}

.chat-container {
  flex: 1;
  overflow: hidden;
}
</style>
